import { createReducer } from 'redux-act';
import actions from '../actions/commonActions';

const initialState = {
  sidebarOptions: { minimize: false, show: 'responsive' },
  messageNotification: null,

  getAppConstantDataPending: false,
  getAppConstantDataRes: null,
  getAppConstantDataError: null,

  getDateConstantPending: false,
  getDateConstantRes: null,
  getDateConstantError: null,
  
  getConstantByCategorySubcategoryPending: false,
  getConstantByCategorySubcategoryRes: null,
  getConstantByCategorySubcategoryError: null,

  checkInCheckOutMachinePending: false,
  checkInCheckOutMachineRes: null,
  checkInCheckOutMachineError: null,
};

/* Toggle Sidebar Reducers */
const handleToggleSidebar = (state, payload) => {
  return {
    ...state,
    ...{
      sidebarOptions: payload,
    },
  };
};

/* Clear Existing Data Reducers*/
const clearCommonStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR':
      return {
        ...state,
        ...{
          sidebarOptions: { minimize: false, show: 'responsive' },
        },
      };
    default:
      return state;
  }
};
const handleMessageNotificationRequestReducer = (state, payload) => {
  return {
    ...state,
    ...{
      messageNotification: null,
    },
  };
};
const handleMessageNotificationSuccessReducer = (state, payload) => {
  return {
    ...state,
    ...{
      messageNotification: payload,
    },
  };
};

const handleToastMessage =(state,payload)=>{
  switch (payload) {
    case 'HANDLE_TOAST_REQUEST':
      return {
        ...state,
        ...{

        },
      };
    case 'HANDLE_TOAST_ERROR':
      return {
        ...state,
        ...{
          
        },
      };
      case 'HANDLE_TOAST_SUCCESS':
      return {
        ...state,
        ...{
          
        },
      };
    default:
      return state;
    }
  
}


/* Get App Constant Data Reducers*/
const handleGetAppConstantDataRequest = state1 => {
  return {
    ...state1,
    ...{
      getAppConstantDataPending: true,
      getAppConstantDataRes: null,
      getAppConstantDataError: null,
    },
  };
};
const handleGetAppConstantDataSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAppConstantDataPending: false,
      getAppConstantDataRes: payload,
      getAppConstantDataError: null,
    },
  };
};

const handleGetAppConstantDataError = (state1, payload) => ({
  ...state1,
  ...{
    getAppConstantDataPending: false,
    getAppConstantDataRes: null,
    getAppConstantDataError: payload,
  },
});

/* Get App Constant Data Reducers*/
const handleGetDateConstantRequest = state1 => {
  return {
    ...state1,
    ...{
      getDateConstantPending: true,
      getDateConstantRes: null,
      getDateConstantError: null,
    },
  };
};
const handleGetDateConstantSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getDateConstantPending: false,
      getDateConstantRes: payload,
      getDateConstantError: null,
    },
  };
};
const handleGetDateConstantError = (state1, payload) => ({
  ...state1,
  ...{
    getDateConstantPending: false,
    getDateConstantRes: null,
    getDateConstantError: payload,
  },
});

// clear existing data
const clearCreateGetDateConstantStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_GET_DATE_CONSTANT_STORE':
      return {
        ...state,
        ...{
          getDateConstantPending: false,
          getDateConstantRes: null,
          getDateConstantError: null,
        },
      };
    default:
      return state;
  }
};
/* Get App Constant Data Reducers*/
const handleGetConstantByCategorySubcategoryRequest = state1 => {
  return {
    ...state1,
    ...{
      getConstantByCategorySubcategoryPending: true,
      getConstantByCategorySubcategoryRes: null,
      getConstantByCategorySubcategoryError: null,
    },
  };
};
const handleGetConstantByCategorySubcategorySuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getConstantByCategorySubcategoryPending: false,
      getConstantByCategorySubcategoryRes: payload,
      getConstantByCategorySubcategoryError: null,
    },
  };
};
const handleGetConstantByCategorySubcategoryError = (state1, payload) => ({
  ...state1,
  ...{
    getConstantByCategorySubcategoryPending: false,
    getConstantByCategorySubcategoryRes: null,
    getConstantByCategorySubcategoryError: payload,
  },
});

/* Check In Check Out Machine Reducers*/
const handleCheckInCheckOutMachineRequest = state1 => {
  return {
    ...state1,
    ...{
      checkInCheckOutMachinePending: true,
      checkInCheckOutMachineRes: null,
      checkInCheckOutMachineError: null,
    },
  };
};
const handleCheckInCheckOutMachineSuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      checkInCheckOutMachinePending: false,
      checkInCheckOutMachineRes: payload,
      checkInCheckOutMachineError: null,
    },
  };
};
const handleCheckInCheckOutMachineError = (state1, payload) => ({
  ...state1,
  ...{
    checkInCheckOutMachinePending: false,
    checkInCheckOutMachineRes: null,
    checkInCheckOutMachineError: payload,
  },
});




export default createReducer(
  {
    [actions.toggleSidebar]: handleToggleSidebar,
    [actions.handleClearCommonStore]: clearCommonStore,
    [actions.handleMessageNotificationRequest]: handleMessageNotificationRequestReducer,
    [actions.handleMessageNotificationSuccess]: handleMessageNotificationSuccessReducer,

    [actions.getAppConstantDataRequest]: handleGetAppConstantDataRequest,
    [actions.getAppConstantDataSuccess]: handleGetAppConstantDataSuccess,
    [actions.getAppConstantDataError]: handleGetAppConstantDataError,

    [actions.getDateConstantRequest]: handleGetDateConstantRequest,
    [actions.getDateConstantSuccess]: handleGetDateConstantSuccess,
    [actions.getDateConstantError]: handleGetDateConstantError,

    [actions.handleClearGetDateConstantStore]: clearCreateGetDateConstantStore,
    
    [actions.getConstantByCategorySubcategoryRequest]: handleGetConstantByCategorySubcategoryRequest,
    [actions.getConstantByCategorySubcategorySuccess]: handleGetConstantByCategorySubcategorySuccess,
    [actions.getConstantByCategorySubcategoryError]: handleGetConstantByCategorySubcategoryError,

    [actions.checkInCheckOutMachineRequest]: handleCheckInCheckOutMachineRequest,
    [actions.checkInCheckOutMachineSuccess]: handleCheckInCheckOutMachineSuccess,
    [actions.checkInCheckOutMachineError]: handleCheckInCheckOutMachineError,
  },
  initialState,
);
